/**
 * A collection of String-based constants.
 * @hidden
 * @ignore Exclude from docs
 */
/**
 * @ignore Exclude from docs
 */
export var PX = "px";
/**
 * @ignore Exclude from docs
 */
export var STRING = "string";
/**
 * @ignore Exclude from docs
 */
export var NUMBER = "number";
/**
 * @ignore Exclude from docs
 */
export var DATE = "date";
/**
 * @ignore Exclude from docs
 */
export var DURATION = "duration";
/**
 * @ignore Exclude from docs
 */
export var PLACEHOLDER = "__§§§__";
/**
 * @ignore Exclude from docs
 */
export var PLACEHOLDER2 = "__§§§§__";
//# sourceMappingURL=Strings.js.map